import { createAction } from 'redux-act';
// add candidate action
const createCandidateRequest = createAction('CREATE_CANDIDATE_REQUEST', data => data);
const createCandidateSuccess = createAction('CREATE_CANDIDATE_SUCCESS', data => data);
const createCandidateError = createAction('CREATE_CANDIDATE_ERROR');

// update candidate action
const updateCandidateDetailsRequest = createAction('UPDATE_CANDIDATE_REQUEST', data => data);
const updateCandidateDetailsSuccess = createAction('UPDATE_CANDIDATE_SUCCESS', data => data);
const updateCandidateDetailsError = createAction('UPDATE_CANDIDATE_ERROR');


// get candidate action
const getAllCandidateRequest = createAction('GET_ALL_CANDIDATE_REQUEST', data => data);
const getAllCandidateSuccess = createAction('GET_ALL_CANDIDATE_SUCCESS', data => data);
const getAllCandidateError = createAction('GET_ALL_CANDIDATE_ERROR');

const saveCandidateDataRequest = createAction('SAVE_CANDIDATE_DATA_REQUEST', data => data);

// clear candidate action
const handleClearCandidateStore = createAction('HANDLE_CLEAR_CANDIDATE_STORE', data => data);

export default {
    createCandidateRequest,
    createCandidateSuccess,
    createCandidateError,

    updateCandidateDetailsRequest,
    updateCandidateDetailsSuccess,
    updateCandidateDetailsError,

    getAllCandidateRequest,
    getAllCandidateSuccess,
    getAllCandidateError,

saveCandidateDataRequest,
    handleClearCandidateStore

}   